/**
 * Created by glopez on 13/06/17.
 */
import {Actions} from 'store/actions/pages/series';

/**
 * Returns the linear channels status state.
 *
 * @param {Object} state - Current state.
 * @param {Object} action - Action object.
 * @returns {Object} State.
 */
function seriesPageById (state = {}, action) {

    switch (action.type) {

        case Actions.REQUEST_SERIES_PAGE:
            return Object.assign({}, state, {
                seriesId: action.seriesId
            });

        case Actions.RECEIVE_SERIES_PAGE:
            return Object.assign({}, state, {
                series: action.series,
                episodes: action.episodes
            });

        case Actions.SET_BOOKMARKS:
            return Object.assign({}, state, {
                bookmarks: action.bookmarks
            });

        default:
            return state;
    }
}

/**
 * Returns the series page state.
 *
 * @param {Object} state - Current state.
 * @param {Object} action - Action object.
 * @returns {Object} State.
 */
export default function series (state = {}, action) {
    return seriesPageById(state, action);
}


// WEBPACK FOOTER //
// ./src/js/store/reducers/pages/series.js